import { render } from "./AutomatedScenarioEditor.vue?vue&type=template&id=4f5caee0"
import script from "./AutomatedScenarioEditor.vue?vue&type=script&lang=ts"
export * from "./AutomatedScenarioEditor.vue?vue&type=script&lang=ts"

import "./AutomatedScenarioEditor.vue?vue&type=style&index=0&id=4f5caee0&lang=scss"
script.render = render

export default script